import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { OrderAddInfoPage } from "#/components/pages/order-add-info/order-add-info-page";

export const Route = createFileRoute("/$tenantCode/$market/order-add-info")({
  beforeLoad: () => ({ getTitle: () => m["resources.orderAddInfo.name"]() }),
  component: OrderAddInfoPage,
});
